import { render, staticRenderFns } from "./TasksMade.vue?vue&type=template&id=98ffc072&scoped=true"
import script from "./TasksMade.vue?vue&type=script&lang=js"
export * from "./TasksMade.vue?vue&type=script&lang=js"
import style0 from "./TasksMade.vue?vue&type=style&index=0&id=98ffc072&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ffc072",
  null
  
)

export default component.exports